// extracted by mini-css-extract-plugin
export var container = "_bd-0";